import UserStatusEnum from '@constants/enums/user/status';

import i18n from '@plugins/i18n';

import { Collection, Nominee } from '@/models';

export class SystemNomineesCollection extends Collection {
    static type = 'SystemNomineesCollection';
    static endpoint = Nominee.api.index;
    static model = Nominee;

    get default_headers() {
        return ['name', 'status', 'gi_ref', 'fca_number'];
    }

    get headers() {
        return [
            this.createHeader('id', i18n.t('id'), {
                classList: ['no-wrap'],
                width: '20rem',
                filterable: {
                    operators: this.getOperators(['eq'])
                }
            }),
            this.createHeader('name', i18n.t('name'), {
                filterable: true,
                width: '18rem',
                minWidth: '18rem'
            }),
            this.createHeader('status', i18n.t('status'), {
                filterable: true,
                width: '10rem',
                format: 'enum',
                enum: UserStatusEnum,
                enumA11yKey: 'enums.user_status',
                enumTypes: {
                    [UserStatusEnum.ACTIVE]: 'success',
                    [UserStatusEnum.INACTIVE]: 'grey',
                    [UserStatusEnum.SUSPENDED]: 'error',
                    [UserStatusEnum.UNVERIFIED]: 'warning'
                }
            }),
            this.createHeader('gi_ref', i18n.t('gi_ref'), {
                filterable: true,
                width: '9rem'
            }),
            this.createHeader('fca_number', i18n.t('fca_number'), {
                filterable: true,
                width: '12rem'
            }),
            this.createHeader('control', '', {
                format: 'control',
                width: '7rem',
                persistent: true
            })
        ];
    }
}

export default SystemNomineesCollection;
